
import { mirandaMediaArray } from './mirandaMedia'
import { carrieReviewerProfile, charlotteReviewerProfile, samanthaReviewerProfile } from './mirandaReviewers'
import { samanthaBio, carrieBio, charlotteBio, mirandaBio } from './mirandaBios'
import { mirandaDatingProfileHinge, mirandaDatingProfileBumble, mirandaDatingProfileTinder } from './mirandaDatingProfiles'

export const mirandaUser = {
  _id: 'mirandaUserId',
  email: 'miranda@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...carrieReviewerProfile },
    { ...charlotteReviewerProfile },
    { ...samanthaReviewerProfile }
  ],
  media: [ ...mirandaMediaArray ],
  bio: { ...mirandaBio },
  datingProfiles: [
    { ...mirandaDatingProfileHinge },
    { ...mirandaDatingProfileBumble },
    { ...mirandaDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const carrieUser = {
  _id: 'carrieUserId',
  email: 'carrie@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...carrieBio },
  datingProfiles: [],
  reviewerProfile: { ...carrieReviewerProfile },
}

export const charlotteUser = {
  _id: 'charlotteUserId',
  email: 'charlotte@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...charlotteBio },
  datingProfiles: [],
  reviewerProfile: { ...charlotteReviewerProfile },
}

export const samanthaUser = {
  _id: 'samanthaUserId',
  email: 'samantha@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...samanthaBio },
  datingProfiles: [],
  reviewerProfile: { ...samanthaReviewerProfile },
}
